import DOMPurify from "dompurify";
import { parseHTML } from "linkedom";

type SanitizeConfig = Parameters<typeof DOMPurify.sanitize>[1];

// DOMPurify needs a real DOM. In the browser it uses `window` directly; on the
// server (Cloudflare Worker SSR) there is no `window`, so we build a minimal
// DOM with linkedom (Worker-compatible, no native deps) and hand it to
// DOMPurify's factory form so content is sanitized before it reaches visitors.
type PurifyInstance = {
  sanitize: (input: string, cfg?: SanitizeConfig) => string;
};

let serverPurify: PurifyInstance | undefined;

function getServerPurify(): PurifyInstance {
  if (serverPurify) return serverPurify;
  const { window } = parseHTML("<!doctype html><html><body></body></html>");
  const factory = DOMPurify as unknown as (win: unknown) => PurifyInstance;
  serverPurify = factory(window);
  return serverPurify;
}

export function sanitizeHtml(html: string, config?: SanitizeConfig): string {
  if (typeof window === "undefined") {
    return getServerPurify().sanitize(html, config);
  }
  const purify = DOMPurify as unknown as Partial<PurifyInstance>;
  if (typeof purify.sanitize !== "function") return html;
  return purify.sanitize(html, config);
}
